import { NAV_ITEMS } from '@suvoda-uat/ui-suvoda';
import { canManageTeam } from './auth.js';

export type NavItem = (typeof NAV_ITEMS)[number];

/**
 * The sidebar items the current user may see (feature 015): "Team" renders
 * ONLY for admins. The filter lives here — where roles are known — so the
 * ui-suvoda Sidebar stays presentational; the server 403s regardless.
 */
export const visibleNavItems = (canSeeTeam: boolean = canManageTeam()): NavItem[] =>
  NAV_ITEMS.filter((item) => item.id !== 'team' || canSeeTeam);

/** The route for a sidebar nav id; undefined ⇒ no navigation target (yet). */
export const navTargetFor = (id: string): '/' | '/team' | undefined => {
  if (id === 'dashboard') return '/';
  if (id === 'team') return '/team';
  return undefined;
};
